export const DEFAULT_IMAGE_PLACEHOLDER = `data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E`
export const DEV_DEFAULT_THUMBHASH = 'lNYNDIRfm2ZliIiHeHcGYfFhKA'
export const DEFAULT_PRELOAD_ROOT_MARGIN = '75vh'
export const REVEAL_ANIMATION_THRESHOLD_MS = 120
/** Matches the `duration-200` fade on the placeholder image. */
export const PLACEHOLDER_FADE_MS = 200
